module.exports = __webpack_public_path__ + "static/media/1-2.b071ccc7.png";